import { namespaces } from '@common'

export const namespace = namespaces.insurance.value
export const schema = 'benefitSchema'
export const backendDocType = 'Benefit'
export const docPrivilege = 'insurance'
